import dragDropUtils from '../dragdrop/utils';
import canvasUtils from '../utils';

export default class Element {
  constructor(element, eventBus) {
    this.listeners = {};
    this.eventBus = eventBus;
    this.element = element;
    this.document = this.element.ownerDocument;
    this.childrenSelected = [];
    if (this.element.hasAttribute('data-gp-component-id')) {
      this.id = this.element.getAttribute('data-gp-component-id');
    } else if (canvasUtils.getComponentIdFromClass(element)) {
      this.id = canvasUtils.getComponentIdFromClass(element);
    } else {
      this.id = canvasUtils.uniqueId();
    }
    this.componentType = this.element.getAttribute('data-gp-component');
    this.registerElement();
    if (this.element.ownerDocument.getElementById('page-container'))
      this.page = this.element.ownerDocument
        .getElementById('page-container')
        .getAttribute('data-gp-page-id');
  }

  registerElement() {
    this.draggable = this.element.hasAttribute('data-gp-dnd');
    this.textEditable = this.element.hasAttribute('data-gp-text');
    this.element.classList.add('gp-component');
    this.element.classList.add(`gp-component-id-${this.id}`);
    this.element.setAttribute('data-gp-component-id', this.id);
    this.element.setAttribute('data-gp-component', this.componentType);
    if (this.element.hasAttribute('data-gp-text')) {
      [...this.element.children].forEach((child) => {
        if (
          !child.getAttribute('class') ||
          !child.getAttribute('class').includes('gp-component-id-')
        ) {
          child.classList.add(`gp-component-id-${canvasUtils.uniqueId()}`);
        }
      });
    }
    this.type = 'Component';
    if (this.element.hasAttribute('data-gp-block')) {
      this.type = 'Block';
      this.isBlock = true;
    } else if (this.element.hasAttribute('data-gp-container')) {
      this.type = 'Container';
    } else if (this.element.hasAttribute('data-gp-text')) {
      this.childrenSelected = [
        canvasUtils.getComponentIdFromClass(
          this.getElement().querySelector(
            '[class*="gp-component-id-"]:not(.ql-editor)'
          )
        ),
      ];
      this.type = 'Text';
    }
    if (this.element.hasAttribute('data-gp-style')) {
      this.styleEditable = true;
      if (this.element.getAttribute('data-gp-component') == 'null') {
        this.configComponent = this.getConfigComponent();
        if (this.configComponent) {
          this.configType = this.configComponent.getAttribute(
            'data-gp-component'
          );
          this.configId = this.configComponent.getAttribute(
            'data-gp-component-id'
          );
        }
      }
    }
    this.element.setAttribute('data-gp-component', this.componentType);
    canvasUtils.reflashComponentAttributes(this.element);
  }

  getElement() {
    return this.document.querySelector(`[data-gp-component-id="${this.id}"]`);
  }

  getConfigComponent() {
    return this.element.parentNode.closest(
      '[data-gp-component]:not([data-gp-component="null"])'
    );
  }

  parentComponent() {
    if (this.isBlock) return false;
    const parentElement = this.element.parentNode.closest('.gp-component');
    if (parentElement)
      return parentElement.getAttribute('data-gp-component-id');
    return null;
  }

  updateContent(html) {
    this.eventBus.$emit('canvas-pre-change');
    const content = document.createElement('div');
    content.innerHTML = html;
    const newElement = content.children[0];
    this.element = this.getElement();
    this.element.replaceWith(newElement);
    this.element = newElement;
    this.element.setAttribute('data-gp-component', this.componentType);
    this.registerElement();
    this.eventBus.$emit('canvas-change');
  }

  getMenu(extraItems) {
    const menu = document.createElement('div');
    menu.setAttribute('data-gp-menu-component-id', this.id);
    menu.classList.add('gp-component-menu');
    extraItems.forEach((button) => {
      menu.appendChild(button);
    });
    const copyIcon = canvasUtils.getMenuButton('icon-single-copy-04');

    // check for groovemember
    if(this.element.id !== 'groovemember-content-box'){
      menu.appendChild(copyIcon);
    }
    copyIcon.addEventListener('click', () => this.clone());

    const removeIcon = canvasUtils.getMenuButton('icon-trash');

    // check for groovemember
    if(this.element.id !== 'groovemember-content-box'){
      menu.appendChild(removeIcon);
    }


    removeIcon.addEventListener('click', () => this.delete());

    if (this.parentComponent()) {
      const parentButton = canvasUtils.getMenuButton(
        'icon-move-layer-up',
        'gp-yellow'
      );
      menu.appendChild(parentButton);
      parentButton.addEventListener('click', () => this.jumpToParent());
    }

    return menu;
  }

  clone(silent) {
    this.eventBus.$emit('canvas-pre-change');
    const clone = this.element.cloneNode(true);
    this.element.parentNode.insertBefore(clone, this.element.nextSibling);
    canvasUtils.componentCloned(clone, this.eventBus);
    this.eventBus.$emit('canvas-change');
    if (!silent) {
      this.eventBus.$emit(
        'select-element-request',
        clone.getAttribute('data-gp-component-id')
      );
    }
    return clone.getAttribute('data-gp-component-id');
  }

  delete() {
    const confirmDelete = () => {
      this.eventBus.$emit('canvas-pre-change');
      this.element.remove();
      canvasUtils.triggerEvent(
        this.element.ownerDocument.defaultView,
        'resize'
      );
      this.eventBus.$emit('canvas-change');
    };
    this.eventBus.$emit('action-request', { callback: confirmDelete });
  }

  moveUp() {
    
    this.eventBus.$emit('canvas-pre-change');

    const clone = this.element.cloneNode(true);

    this.element.parentNode.insertBefore(clone, this.element.previousSibling);
    
    this.element.remove();

    this.eventBus.$emit('canvas-change');
  }

  moveDown() {    

    this.eventBus.$emit('canvas-pre-change');

    const clone = this.element.nextSibling.cloneNode(true);

    this.element.parentNode.insertBefore(clone, this.element);

    this.element.nextSibling.remove();

    this.eventBus.$emit('canvas-change');
  }

  jumpToParent() {
    this.eventBus.$emit('select-element-request', this.parentComponent());
  }

  setTextPlaceholder() {
    if (this.textEditable && this.element.textContent.trim() === '') {
      this.element.querySelector(
        '[class*="gp-component-id-"]:not(.ql-editor)'
      ).innerHTML = 'ADD TEXT HERE.';
    }
  }

  editText() {
    this.eventBus.$emit('canvas-pre-change');
    this.eventBus.$emit('edit-text', {
      element: this,
    });
    const callback = (element) => {
      if (element && element.id === this.id) return;
      this.childrenSelected = [
        canvasUtils.getComponentIdFromClass(
          this.getElement().querySelector('[class*="gp-component-id-"]')
        ),
      ];
      this.eventBus.$off('select-element', callback);
      this.eventBus.$emit('canvas-change');
    };
    this.eventBus.$on('select-element', callback);
  }

  replaceContent(content) {
    this.element.innerHTML = content;
    dragDropUtils.removeDragState(this.element);
  }

  getContent() {
    return this.element.innerHTML;
  }
}
